// extracted by mini-css-extract-plugin
export default {"expWrapper":"Experience_expWrapper__7oCdk","infosExp":"Experience_infosExp__tOot+","eduWrapper":"Experience_eduWrapper__YXkUH","dates":"Experience_dates__ZZghT"};